<template>
  <catalogo-detail-view
    :table-name="'ciudades'"
    table-title="Ciudad"
    :readonly-fields="['Id','created','updated']"
    :labels="{Id:'#', IsActive:'Activo', Created:'Creado', Updated:'Actualizado'}"
    back-route="/geograficos/ciudades"
  />
</template>

<script>
import catalogoDetailView from '@/components/catalogoDetailView.vue';

export default {
  components: { catalogoDetailView },
};

</script>
